export default "__VITE_ASSET__c5a0b35d__"